import { IResponsesValue, IWordBank, ISchool } from 'types'

export default class SnapshotService {
  static get responseTypes(): string[] {
    return ['selfTag']
  }

  static getResponseList(responses: IResponsesValue) {
    return SnapshotService.responseTypes.reduce((acc, type) => {
      const typeResponses =
        responses && responses[type] ? responses[type].map((response: IWordBank) => response.value) : []
      return acc.concat(typeResponses)
    }, [] as string[])
  }

  static getJobDescription(responses: IResponsesValue) {
    let jobDescription = ''

    if (responses && responses.currentRole) {
      jobDescription += responses?.currentRole
      if (responses.currentCompany) {
        jobDescription += ` at ${responses?.currentCompany}`
      }
    }
    return jobDescription
  }

  static getSchoolDescription(responses: IResponsesValue): string {
    const schoolTypeOrder = ['graduate', 'undergrad']

    let schools: ISchool[] = []

    if (responses?.schools) {
      schools = [...responses?.schools]
    }

    const school = schools
      .sort((a: any, b: any) => {
        return a.gradYear - b.gradYear || schoolTypeOrder.indexOf(b.schoolType) - schoolTypeOrder.indexOf(a.schoolType)
      })
      .pop()

    if (school) {
      let formattedSchoolInfo = school.schoolName

      if (school.gradYear) {
        formattedSchoolInfo = `${formattedSchoolInfo} '${school.gradYear.toString().slice(-2)}`
      }

      return [formattedSchoolInfo, school.fieldOfStudy, school.degreeType].filter(it => !!it).join(' | ')
    }

    return ''
  }
}
